export default __webpack_public_path__ + "static/premiosParticipa_DO-836aae98241db5651f635b9e6475fae3.png";